<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BasketballMatchSummary',
  computed: {
    data() {
      return this.update.Data;
    },
    teams() {
      return this.fixture.Name.includes(' v ')
        ? this.fixture.Name.split(' v ')
        : this.fixture.Competitors
          ? [
              this.fixture.Competitors.find((c) => c?.HomeAway === 'Home'),
              this.fixture.Competitors.find((c) => c?.HomeAway === 'Away'),
            ]
          : ['Команда 1', 'Команда 2'];
    },
  },
  props: ['update', 'fixture'],
});
</script>

<template>
  <section v-if="update">
    <div
      :class="{
        'grid grid-flow-col grid-rows-3 w-max': true,
        '[grid-template-columns:repeat(auto-fit,max-content)]': true,
        'text-center border-gray-500': true,
        'custom-cells m-auto my-2': true,
      }"
    >
      <div class="h">Часы идут</div>
      <div class="b row-span-2 place-content-center">
        <i class="pi pi-check text-green-500 text-lg" v-if="data.IsClockRunning" />
        <i class="pi pi-times text-red-500 text-lg" v-else />
      </div>

      <div class="h">Ост.время</div>
      <div class="b font-mono text-lg row-span-2 place-content-center">
        {{
          Math.floor(data.TimeRemainingInPhaseAtTimestamp?.TimeRemainingInPhaseMilliseconds / 1000)
        }}
      </div>

      <div class="h">Фаза</div>
      <div class="b text-lg row-span-2 place-content-center">{{ data.CurrentPhase }}</div>

      <div class="!text-left h">Команды</div>
      <div class="text-gray-500 !text-left">{{ teams[0] }}</div>
      <div class="b text-gray-500 !text-left">{{ teams[1] }}</div>

      <div class="!text-sm !pt-3 h">Фолы</div>
      <div class="font-mono">{{ data.FoulCount?.Home }}</div>
      <div class="b font-mono">{{ data.FoulCount?.Away }}</div>

      <div class="!text-sm !pt-3 h">1/4</div>
      <div class="font-mono text-gray-500">{{ data.Scores.FirstQuarterScore?.Home }}</div>
      <div class="b font-mono text-gray-500">{{ data.Scores.FirstQuarterScore?.Away }}</div>

      <div class="!text-sm !pt-3 h">2/4</div>
      <div class="font-mono text-gray-500">{{ data.Scores.SecondQuarterScore?.Home }}</div>
      <div class="b font-mono text-gray-500">{{ data.Scores.SecondQuarterScore?.Away }}</div>

      <div class="!text-sm !pt-3 h">1/2</div>
      <div class="font-mono">{{ data.Scores.FirstHalfScore?.Home }}</div>
      <div class="b font-mono">{{ data.Scores.FirstHalfScore?.Away }}</div>

      <div class="!text-sm !pt-3 h">3/4</div>
      <div class="font-mono text-gray-500">{{ data.Scores.ThirdQuarterScore?.Home }}</div>
      <div class="b font-mono text-gray-500">{{ data.Scores.ThirdQuarterScore?.Away }}</div>

      <div class="!text-sm !pt-3 h">4/4</div>
      <div class="font-mono text-gray-500">{{ data.Scores.FourthQuarterScore?.Home }}</div>
      <div class="b font-mono text-gray-500">{{ data.Scores.FourthQuarterScore?.Away }}</div>

      <div class="!text-sm !pt-3 h">2/2</div>
      <div class="font-mono">{{ data.Scores.SecondHalfScore?.Home }}</div>
      <div class="b font-mono">{{ data.Scores.SecondHalfScore?.Away }}</div>

      <div class="!text-sm !pt-3 h">O/T</div>
      <div class="font-mono">{{ data.Scores.OvertimeScore?.Home }}</div>
      <div class="b font-mono">{{ data.Scores.OvertimeScore?.Away }}</div>

      <div class="r h">Текущий счет</div>
      <div class="r font-mono text-lg">{{ data.Scores.CurrentScore?.Home }}</div>
      <div class="r b font-mono text-lg">{{ data.Scores.CurrentScore?.Away }}</div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.custom-cells {
  & > div {
    @apply px-3 pt-2 pb-1 text-lg;
    @apply border border-gray-500;

    &:not(.r) {
      @apply border-r-0;
    }

    &:not(.b) {
      @apply border-b-0;
    }

  }

  & > div.h {
    @apply bg-gray-300 dark:bg-gray-700;
  }
}
</style>
